<template>
  <div>
    <article class="media">
      <div class="media-content">
        <div class="content">



          <div class="columns">
            <div class="column">
              <b-field label="Mes">
                <b-select expanded v-model="month" placeholder="Selecciona un mes">
                  <option
                    v-for="mes in monthsList"
                    :value="mes.id"
                    :key="mes.id">
                    {{ mes.name }}
                  </option>
                </b-select>

              </b-field>
            </div>

            <div class="column">
              <b-field label="Año">

                <b-select expanded v-model="year" placeholder="Selecciona un año">
                  <option
                    v-for="anio in yearsList"
                    :value="anio"
                    :key="anio">
                    {{ anio }}
                  </option>
                </b-select>
              </b-field>
            </div>

          </div>

          <div class="center">
            <button :disabled="!validateFilters" @click="goSearchReport" class="button is-info is-rounded ">Consultar</button>
          </div>


        </div>

        <div class="report">

          <!-- <h3 class="title is-size-6" v-show="total>0">{{total}} registros encontrados...</h3>
          <h3 class="title is-size-6" v-show="boxes>0">{{boxes}} cajas registradas...</h3> -->

          <!-- <b-table
            :data="fileList"
            :hoverable="true"
            :mobile-cards="true"
            paginated
            backend-pagination
            :total="total"
            :per-page="searchOptions.perPage"
            @page-change="onPageChange"
            :current-page="searchOptions.pageNumber"
          >

            <template  slot-scope="props">

              <b-table-column field="name" label="Nombre"   class="is-size-7">
                {{ props.row.name }}
              </b-table-column>


              <b-table-column    label="Código"    class="is-size-7">
                {{ props.row.code }}
              </b-table-column>

              <b-table-column  label="Descripción"   class="is-size-7">
                {{ props.row.description }}
              </b-table-column>

              <b-table-column  label="Caja"    class="is-size-7">
                {{ props.row.box }}
              </b-table-column>


              <b-table-column field="registrationDate" label="Fecha de registro"  centered  class="is-size-7">
                {{ new Date(props.row.registrationDate) | moment("DD/MM/YYYY") }}
              </b-table-column>


              <b-table-column field="status" label="Estado"  centered  class="is-size-7">
                <b-tag v-if="props.row.status" :type="classStatusFile(props.row.status)">{{ props.row.status | StatusFile}}</b-tag>
              </b-table-column>

            </template>


            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon
                      icon="emoticon-sad"
                      size="is-large">
                    </b-icon>
                  </p>
                  <p>Sin resultados.</p>
                </div>
              </section>
            </template>


          </b-table> -->

          <div class="btn-export report" v-show="listBoxes.length>0">
            <div>
              <button  @click="downloadReportPdf" class="button  is-small">
                <b-icon icon="file-pdf" class="colour-pdf"></b-icon> <span style="font-weight:bold"> Descargar PDF </span>
              </button>

              <button  @click="downloadReportExcel" class="button  is-small">
                <b-icon icon="file-excel" class="colour-excel"></b-icon> <span style="font-weight:bold"> Descargar Excel </span>
              </button>
            </div>
          </div>

           <b-table
            :data="listBoxes"
            :hoverable="true"
            :mobile-cards="true"
          >

            <template  slot-scope="props">

              <b-table-column  label="Cliente" centered  class="is-size-7">
                {{ props.row.cliente }}
              </b-table-column>

              <b-table-column  label="Año"  centered  class="is-size-7">
                {{ props.row.anio }}
              </b-table-column>

              <b-table-column  label="Mes"  centered  class="is-size-7">
                {{ props.row.mes }}
              </b-table-column>

              <b-table-column  label="Cajas" centered   class="is-size-7">
                {{ props.row.totalBox }}
              </b-table-column>

               <b-table-column  label="Registros"  centered  class="is-size-7">
                {{ props.row.totalFile }}
              </b-table-column>


            </template>


            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon
                      icon="emoticon-sad"
                      size="is-large">
                    </b-icon>
                  </p>
                  <p>Sin resultados.</p>
                </div>
              </section>
            </template>


          </b-table>

        </div>


      </div>
    </article>
  </div>
</template>



<script>

  import {mapActions} from 'vuex'
  import Util from '../../../util'
  import BoxesByMonthApi from '../../../api/modules/BoxesByMonthApi'
  export default {
    name: "files-by-registration-date",
    data(){
      //calculo Anios
      var yearCtrl=2017
      const limit = new Date().getFullYear() - yearCtrl
      const arrayYears= [yearCtrl]
      for (var i = 0; i < limit; i++) {
        yearCtrl++
        arrayYears.push(yearCtrl)
      }

      return {
        //filters
        monthsList:[{id:1,name:'Enero'},
          {id:2,name:'Febrero'},
          {id:3,name:'Marzo'},
          {id:4,name:'Abril'},
          {id:5,name:'Mayo'},
          {id:6,name:'Junio'},
          {id:7,name:'Julio'},
          {id:8,name:'Agosto'},
          {id:9,name:'Septiembre'},
          {id:10,name:'Octubre'},
          {id:11,name:'Noviembre'},
          {id:12,name:'Diciembre'},],
        yearsList:arrayYears,
        year:null,
        month:null,

        searchOptions: {perPage: 10, pageNumber: 1,sortField:'name',sortOrder:'asc'},
        defaultSortOrder: 'asc',
        //data
        fileList:[],
        total: 0,
        boxes:0,
        listBoxes: []


      }
    },


    methods: {
      ...mapActions({'loadFilesByMonth':'reports/loadFilesByMonth',
                    'loadBoxesByMonth':'reports/loadBoxesByMonth'}),
      classStatusFile(status) {
        return status=='stock'?'is-success':status=='req'?'is-warning':status=='trans'?'is-info':status=='out'?'is-black':status=='pickup'?'is-info':status=='transpickup'?'is-info':'is-danger'
      },

      onPageChange(page) {
        this.searchOptions.pageNumber = page
        this.searchReport().then()
      },
      /*
       * Handle sort event
       */
     /* onSort(field, order) {
        this.searchOptions.sortField = field
        this.searchOptions.sortOrder = order
        this.searchReport().then()
      },*/

      goSearchReport(){
        this.searchReport().then(()=>{

          const params = [
            `month=${this.month}`,
            `year=${this.year}`,
            `type=BOX`
          ]
          .join('&')

          // this.loadBoxesByMonth({context:this,params,idClient:Util.getClient().id}).then(data=>{
          BoxesByMonthApi.loadBoxesByMonth(this,{params,idClient:Util.getClient().id}).then(data=>{
            // this.boxes=data
            this.listBoxes=data
          }).catch(error=>this.listBoxes=[])
        })
      },


      downloadReportPdf(){
        const params = [
            `month=${this.month}`,
            `year=${this.year}`,
            `type=BOX`
          ]
          .join('&');

        BoxesByMonthApi.loadReportBoxesByMonthsPDF(this,{params,idClient:Util.getClient().id}).then()
      },

      downloadReportExcel() {
        const params = [
            `month=${this.month}`,
            `year=${this.year}`,
            `type=BOX`
          ]
          .join('&');

        BoxesByMonthApi.loadReportBoxesByMonthsEXCEL(this,{params,idClient:Util.getClient().id}).then()
      },

      searchReport(){
        return new Promise((resolve, reject) => {
          const params = [
            `month=${this.month}`,
            `year=${this.year}`,
            `pageNumber=${this.searchOptions.pageNumber}`,
            `perPage=${this.searchOptions.perPage}`,
            `sortField=${this.searchOptions.sortField}`,
            `sortOrder=${this.searchOptions.sortOrder}`,
          ].join('&')

          this.loadFilesByMonth({context:this,params,idClient:Util.getClient().id}).then(data=>{
            this.fileList=data.files
            this.total = data.count
            resolve()
          }).catch(error=>{
            this.fileList=[]
            this.total = 0
            reject()
          })
        })
      }

    },

    computed: {
      validateFilters(){
        return (this.month !=null && this.year!=null)
      },

    },
    created(){

      this.month=new Date().getMonth()
      this.year=new Date().getFullYear()

    }

  }
</script>
<style  scoped>
.center {
  text-align: center;
}
.colour-pdf {
  color:red;
}
.colour-excel {
  color:green;
}
.btn-export {
  text-align: right;
  margin-bottom: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/reportes/files/BoxesByMonth.vue